// extracted by mini-css-extract-plugin
export default {"colors":"KT8npY16C3QzEDB76cVp","swatch":"AcOicXFcFjyipA6vLG9W","fill":"a4CNwEL1SgEl80K3LT0F","check":"njNdZyDM7ESSBAsB5_zl"};